// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2xJt2","info":"PatientInfo_info__3ZSSS"};